export default class Dropdown {

    constructor(menu, options) {
        this.defaults = {
            onEdit: r => r,
            onDelete: r => r,
            onExport: r => r,
            onExportPDF: r => r,
            onExportExcel: r => r,
            onClone: r => r,
            onFind: r => r,
            onAssign: r => r
        };
        this.section = $("#" + $(menu).parents('section:eq(0)').attr('id'));
        this.name = menu.replace('#', '');
        this.options = $.extend({}, this.defaults, options);
        this.setEvents();
    }

    getFlagged() {
        const ids = [];
        this.section.find('.select:checked').each(function () {
            ids.push($(this).data('id'));
        });
        return ids;
    }

    disable() {
        this.section.find('.multi').click().addClass('disabled');
    }

    setEvents() {
        const self = this;
        const multi = this.section.find('.menu .multi');
        const body = $('body');
        multi.data('orig', multi.text());

        //Check All
        body.off('click.sa' + self.name).on('click.sa' + self.name, '.select-all', function () {
            if ($('.select-all').is(':checked')) {
                $('.select').prop('checked', true).change();
            } else {
                $('.select').prop('checked', false).change();
            }
        });

        //Checked
        body.off('change.s' + self.name).on('change.s' + self.name, '.select', function () {
            self.section.find('.multi').addClass('disabled');
            const ids = self.getFlagged();
            if (ids.length > 0) {
                self.section.find('.multi').removeClass('disabled');
                multi.text(multi.data('orig').replace('With', self.section.find('.select:checked').length));
            } else {
                multi.text(multi.data('orig'));
            }
        });

        //Delete
        self.section.off('click.d' + self.name).on('click.d' + self.name, '.multi-delete', function () {
            self.options.onDelete(self.getFlagged());
            self.disable();
        });

        //Edit
        self.section.off('click.e' + self.name).on('click.e' + self.name, '.multi-edit', function () {
            self.options.onEdit(self.getFlagged());
            self.disable();
        });

        //Export
        self.section.off('click.ex' + self.name).on('click.ex' + self.name, '.multi-export', function () {
            self.options.onExport(self.getFlagged());
        });

        //Export PDF
        self.section.off('click.pdfex' + self.name).on('click.pdfex' + self.name, '.multi-export-pdf', function () {
            self.options.onExportPDF(self.getFlagged());
        });

        //Export XLSX
        self.section.off('click.xlsxex' + self.name).on('click.xlsxex' + self.name, '.multi-export-excel', function () {
            self.options.onExportExcel(self.getFlagged());
        });

        //Clone
        self.section.off('click.cl' + self.name).on('click.cl' + self.name, '.multi-clone', function () {
            self.options.onClone(self.getFlagged());
        });

        //Find
        self.section.off('click.f' + self.name).on('click.f' + self.name, '.multi-find', function () {
            self.options.onFind(self.getFlagged());
            self.disable();
        });

        //Assign
        self.section.off('click.as' + self.name).on('click.as' + self.name, '.multi-assign', function () {
            self.options.onAssign(self.getFlagged());
        });
    }
}
